// src/pages/produtos/destaqueProdutos/DestaqueProdutoSearch.js
import React, { useEffect, useRef, useState } from 'react';
import { FaSortDown, FaSortUp } from 'react-icons/fa';

import { useDestaqueProduto } from '../../../contexts/produtos/DestaqueProdutoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import { normalizeText } from '../../../utils/stringUtils';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const DestaqueProdutoSearch = ({ show, onHide, onSelectDestaqueProduto }) => {
    const { destaqueProdutos } = useDestaqueProduto();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');
    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            setSortField('id');
            setSortDirection('asc');
            inputRef.current?.focus();
        }
    }, [show]);

    if (!show) return null;

    const normalizedFilter = normalizeText(filter);

    const filteredItems = destaqueProdutos.filter((item) => {
        const titulo = normalizeText(item?.titulo || '');
        return titulo.includes(normalizedFilter);
    });

    const sortedItems = [...filteredItems].sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        }

        if (sortField === 'titulo') {
            const valueA = (a.titulo || '').toLowerCase();
            const valueB = (b.titulo || '').toLowerCase();
            if (valueA < valueB) return sortDirection === 'asc' ? -1 : 1;
            if (valueA > valueB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }

        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection((current) => (current === 'asc' ? 'desc' : 'asc'));
            return;
        }

        setSortField(field);
        setSortDirection('asc');
    };

    const handleDoubleClick = (item) => {
        onSelectDestaqueProduto(item);
        onHide();
    };

    return (
        <ModalContainer show={show} largura="850px" zIndex={1080} variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Destaque de Produto" onHide={onHide} />
            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por titulo..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedItems} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    type="button"
                                    onClick={() => handleSort('id')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                >
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '35%' }} aria-sort={sortField === 'titulo' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button
                                    type="button"
                                    onClick={() => handleSort('titulo')}
                                    style={{ fontWeight: 'bold', background: 'none', border: 'none' }}
                                    tabIndex={0}
                                >
                                    Titulo
                                    {sortField === 'titulo' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>
                                Selecionar
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((item) => (
                            <tr key={item.id} onDoubleClick={() => handleDoubleClick(item)}>
                                <td className="text-end align-middle">{item.id}</td>
                                <td className="text-start align-middle">{item.titulo}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton
                                        type="button"
                                        className="btn btn-outline-secondary btn-sm"
                                        onClick={() => onSelectDestaqueProduto(item)}
                                        style={{ padding: '2px 6px' }}
                                     label={item.titulo} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default DestaqueProdutoSearch;
